// Message type constants (includes both message types and widget types)
export const MESSAGE_TYPES = {
  INITIAL: 'initial',
  DECLARATION: 'declaration',
  DECLARATION_WIDGET: 'declaration_widget',
  ASSET_CREATED: 'asset_created',
  CREATE_ASSET: 'create_asset',
  EXTERNAL_TEST_CONFIGURATION: 'external_test_configuration',
  EXTERNAL_TEST_CONFIGURATION_NEW: 'external_test_configuration_new',
  INTERNAL_TEST_CONFIGURATION: 'internal_test_configuration',
  INTERNAL_TEST_CONFIGURATION_NEW: 'internal_test_configuration_new',
  TEST_CONFIGURATION_NEW_ASSET: 'test_configuration_new_asset',
  API_CONFIGURATION: 'api_configuration',

  WEBAPP_EXISTING_EXTERNAL_TEST_CONFIGURATION: 'webapp_existing_external_test_configuration',
  WEBAPP_EXISTING_EXTERNAL_TEST_CONFIGURATION_NEW:
    'webapp_existing_external_test_configuration_new',

  WEBAPP_EXISTING_INTERNAL_TEST_CONFIGURATION: 'webapp_existing_internal_test_configuration',
  WEBAPP_EXISTING_INTERNAL_TEST_CONFIGURATION_NEW:
    'webapp_existing_internal_test_configuration_new',

  WEBAPP_NEW_EXTERNAL_TEST_CONFIGURATION_NEW: 'webapp_new_external_test_configuration_new',
  WEBAPP_NEW_INTERNAL_TEST_CONFIGURATION_NEW: 'webapp_new_internal_test_configuration_new',

  API_EXISTING_INTERNAL_TEST_CONFIGURATION: 'api_existing_internal_test_configuration',
  API_EXISTING_INTERNAL_TEST_CONFIGURATION_NEW: 'api_existing_internal_test_configuration_new',

  API_EXISTING_EXTERNAL_TEST_CONFIGURATION: 'api_existing_external_test_configuration',
  API_EXISTING_EXTERNAL_TEST_CONFIGURATION_NEW: 'api_existing_external_test_configuration_new',

  API_NEW_EXTERNAL_TEST_CONFIGURATION_NEW: 'api_new_external_test_configuration_new',
  API_NEW_INTERNAL_TEST_CONFIGURATION_NEW: 'api_new_internal_test_configuration_new',

  TEST_START: 'test_start',
  TEST_START_VPN: 'test_start_vpn',
  TECH_STACK: 'tech_stack',
  EXTERNAL_TECHSTACK: 'external_techstack',
  INTERNAL_TECHSTACK: 'internal_techstack',
  TARGET_AUTHENTICATION: 'target_authentication',
  CDSA_AUTH: 'cdsa_auth',
  CDSA_UNAUTH: 'cdsa_unauth',
  DYNAMIC_SECURITY_ANALYSIS: 'dynamic_security_analysis',
  CVE: 'cve',
  SDEA: 'sdea',
  GENERAL_SECURITY: 'general_security',
  SECURITY_MISCONFIGURATION_ANALYSIS: 'security_misconfiguration_analysis',
  TEST_CASES_CURATION: 'test_cases_curation',
  VPN: 'vpn',
  TEST_SETUP: 'test_setup',
  DEFAULT_CHECKS: 'default_checks',
  SSL_TLS: 'ssl_tls',
  CONTENT_DISCOVERY: 'content_discovery',
  FINDING_OPTIMIZATION: 'finding_optimization',
  UNAUTH_WORDPRESS_VA: 'unauth_wordpress_va',
  AUTH_WORDPRESS_VA: 'auth_wordpress_va',
  FIREWALL_RESTRICTION: 'firewall_restriction',
  API_COLLECTION: 'api_collection',
  API_DSA: 'api_dsa',
  API_GRAPHQL_SCAN: 'api_graphql_scan',
  TEST_TERMINATE: 'test_terminate',
  EXTERNAL_REACHABILITY_CHECK: 'external_reachability_check',
  REDIRECTION: 'redirection',
  NOT_REACHABLE: 'not_reachable',
  NEW_ADDED_EXTERNAL: 'new_added_external',

  // New message types from backend
  WEB_EXISTING_EXTERNAL: 'web_existing_external',
  WEB_EXISTING_EXTERNAL_REACHABLE_NO_REDIRECTION_NO_HISTORY:
    'web_existing_external_reachable_no_redirection_no_history',
  WEB_EXISTING_EXTERNAL_REACHABLE_NO_REDIRECTION_HISTORY:
    'web_existing_external_reachable_no_redirection_history',
  WEB_EXTERNAL_REACHABLE_REDIRECTION: 'web_external_reachable_redirection',
  EXTERNAL_NOT_REACHABLE: 'external_not_reachable',
  WEB_EXISTING_INTERNAL_NO_HISTORY: 'web_existing_internal_no_history',
  WEB_EXISTING_INTERNAL_HISTORY: 'web_existing_internal_history',
  API_EXISTING_EXTERNAL: 'api_existing_external',
  API_EXISTING_EXTERNAL_REACHABLE: 'api_existing_external_reachable',
  API_EXISTING_EXTERNAL_NOT_REACHABLE: 'api_existing_external_not_reachable',
  API_EXISTING_INTERNAL: 'api_existing_internal',
  NEW_ASSET: 'new_asset',
  WEB_NEW_ADDED_EXTERNAL_REACHABLE_NO_REDIRECTION:
    'web_new_added_external_reachable_no_redirection',
  WEB_NEW_ADDED_INTERNAL: 'web_new_added_internal',
  API_NEW_ADDED_EXTERNAL_REACHABLE: 'api_new_added_external_reachable',
  API_NEW_ADDED_INTERNAL: 'api_new_added_internal',
  API_EXISTING_NO_HISTORY: 'api_existing_no_history',
  API_EXISTING_HISTORY: 'api_existing_history',
  API_INVALID_COLLECTION: 'api_invalid_collection',
  API_NEW_ADDED_VALID_COLLECTION: 'api_new_added_valid_collection',
  TEST_IN_PROGRESS: 'test_in_progress',
  WAF_DETECTED: 'waf_detected',
  ASSET_PERMISSION_DENIED: 'asset_permission_denied',
  STATUS_CODE_403: 'status_code_403',
  STATUS_CODE_404: 'status_code_404',

  // IDOR agent widgets. The auth-verification + refine-scope widgets arrive over the socket;
  // fetching / object-access / declaration / progress / findings are advanced client-side off those payloads.
  IDOR_FETCHING_COLLECTION: 'idor_fetching_collection',
  IDOR_AUTH_VERIFICATION: 'idor_auth_verification',
  IDOR_REFINE_SCOPE: 'idor_refine_scope',
  IDOR_OBJECT_ACCESS: 'idor_object_access',
  IDOR_DECLARATION: 'idor_declaration',
  IDOR_PROGRESS: 'idor_progress',
  IDOR_FINDINGS: 'idor_findings',

  // Scheduled-run system message — emitted strictly after `initial` only when the run
  // was triggered by a schedule. Payload shape:
  //   { type, from: 'system', status: 'completed', timestamp,
  //     widget: { schedule_id, schedule_name, asset_name } }
  // No widget UI / no actions — rendered as a plain system informational bubble.
  SCHEDULED_RUN_STARTED: 'scheduled_run_started',
  NAVIGATION_STEP: 'navigation_step',
  AISO_SCENARIO_EXECUTION: 'aiso_scenario_execution',
};

// Message sources
export const MESSAGE_SOURCES = {
  USER: 'user',
  SYSTEM: 'system',
};

// Message status
export const MESSAGE_STATUS = {
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  TERMINATE: 'terminate',
  // ROAR-4986: a step that was never applicable rather than one that errored — a scenario run that
  // dies before producing findings skips Finding Enrichment. Rendered grey, not red.
  SKIPPED: 'skipped',
};

// Default messages for each message type
export const MESSAGES = {
  [MESSAGE_TYPES.INITIAL]: (url) => (url ? `Initiate GenPT test on ${url}` : 'Initiate GenPT test'),
  [MESSAGE_TYPES.DECLARATION]: 'I understand and confirm the test declaration.',
  [MESSAGE_TYPES.DECLARATION_WIDGET]:
    'We are **go for launch!** 🚀. Your test configuration is locked in. Just one final pre-flight check: Please review and confirm the declaration to start the test!',

  [MESSAGE_TYPES.CREATE_ASSET]:
    "Ooh, uncharted territory! This asset isn't in the registry yet. Let's get it onboarded and ready for action. Please fill in the details below, and I'll create its profile for all future tests.",

  // WEBAPP test configuration messages
  [MESSAGE_TYPES.WEBAPP_EXISTING_EXTERNAL_TEST_CONFIGURATION]:
    "Great news! Your asset is reachable, and I found a previous configuration. I've pre-loaded it for you so you can jump right in. Feel free to review or adjust anything before proceeding.",
  [MESSAGE_TYPES.WEBAPP_EXISTING_EXTERNAL_TEST_CONFIGURATION_NEW]:
    "Alright, I've reviewed the asset, and it appears this will be its first security test. This is an ideal opportunity to establish a clear baseline. Let's proceed with the initial configuration.",
  [MESSAGE_TYPES.WEBAPP_EXISTING_INTERNAL_TEST_CONFIGURATION]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Great, we recognize this one! **${assetName}** has been tested before. To save you time, I've loaded your previous configuration. Feel free to review, modify, or use it as-is to get started.`;
  },
  [MESSAGE_TYPES.WEBAPP_EXISTING_INTERNAL_TEST_CONFIGURATION_NEW]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Excellent! **${assetName}** is already in your inventory, but it looks like it's new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!`;
  },
  [MESSAGE_TYPES.WEBAPP_NEW_EXTERNAL_TEST_CONFIGURATION_NEW]:
    "Great! Now, let's build the game plan. To run the test successfully, I need a few more details. Please set the network, access level, and authentication info below.",
  [MESSAGE_TYPES.WEBAPP_NEW_INTERNAL_TEST_CONFIGURATION_NEW]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Locked in! **${assetName}** has been added successfully. 🎉\n\nNow, let's build the game plan. To run the test successfully, I need a few more details. Please set the access level, and authentication info below.`;
  },

  // API test configuration messages
  [MESSAGE_TYPES.API_EXISTING_INTERNAL_TEST_CONFIGURATION]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Great, we recognize this one! **${assetName}** is already in your inventory. Before moving to test configuration, please share the Collection Source below.`;
  },
  [MESSAGE_TYPES.API_EXISTING_INTERNAL_TEST_CONFIGURATION_NEW]:
    "Thanks! Looks like the asset is new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!",
  [MESSAGE_TYPES.API_EXISTING_EXTERNAL_TEST_CONFIGURATION]:
    'Alright, before we move to test configuration, we just need one quick detail. Please share the Collection Source below.',
  [MESSAGE_TYPES.API_EXISTING_EXTERNAL_TEST_CONFIGURATION_NEW]:
    "Thanks! Looks like the asset is new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!",
  [MESSAGE_TYPES.API_NEW_EXTERNAL_TEST_CONFIGURATION_NEW]:
    "Excellent! Now, let's build the game plan. To run the test successfully, I need a few more details. Please **set the access level, and authentication info** below.",
  [MESSAGE_TYPES.API_NEW_INTERNAL_TEST_CONFIGURATION_NEW]:
    "Excellent! Now, let's build the game plan. To run the test successfully, I need a few more details. Please **set the access level, and authentication info** below.",

  [MESSAGE_TYPES.EXTERNAL_TEST_CONFIGURATION]:
    "Alright! To save your time, I've loaded your previous configuration. Please enter authentication details, if required and feel free to review, modify, or use it as-is to get started.",
  [MESSAGE_TYPES.EXTERNAL_TEST_CONFIGURATION_NEW]:
    "Thanks! Looks like the asset is new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!",
  [MESSAGE_TYPES.INTERNAL_TEST_CONFIGURATION]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Excellent! **${assetName}** is already in your inventory, but it looks like it's new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!`;
  },
  [MESSAGE_TYPES.INTERNAL_TEST_CONFIGURATION_NEW]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Locked in! **${assetName}** has been added successfully. 🎉\n\nNow, let's build the game plan. To run the test successfully, I need a few more details. Please set the access level, and authentication info below.`;
  },
  [MESSAGE_TYPES.TEST_CONFIGURATION_NEW_ASSET]: {
    withAsset: (assetName) =>
      `Locked in! **${assetName}** has been added successfully. 🎉\n\nNow, let's build the game plan. To run the test successfully, I need a few more details. Please set the network, access level, and authentication info below.`,
    default:
      "Now, let's build the game plan. To run the test successfully, I need a few more details. Please set the network, access level, and authentication info below.",
  },
  [MESSAGE_TYPES.API_CONFIGURATION]: {
    withAsset: (assetName) =>
      `Great, we recognize this API! **${assetName}** has been tested before. I've loaded your previous configuration so you can review, tweak, or use it as-is to start the run.`,
    default: "Let's configure your API test. Please review the details below to start the test.",
  },

  [MESSAGE_TYPES.TEST_START]: {
    [MESSAGE_STATUS.IN_PROGRESS]:
      "Perfect! I'm now mapping your application. Let's get this test started!",
    [MESSAGE_STATUS.COMPLETED]: 'Test has been successfully started and is now running.',
  },

  [MESSAGE_TYPES.TEST_START_VPN]: {
    [MESSAGE_STATUS.IN_PROGRESS]:
      "Perfect! I'm now establishing a VPN connection and mapping your internal application. Let's get this test started!",
    [MESSAGE_STATUS.COMPLETED]:
      'VPN connection established and test has been successfully started.',
  },

  [MESSAGE_TYPES.TECH_STACK]: (msg) => {
    const vpnProfile = msg?.metadata?.test_configuration?.vpnProfile;
    if (!vpnProfile) {
      return 'The test is underway. Kicking off the Tech Stack Analysis to discover all public-facing technologies and build a complete profile of your asset.';
    } else {
      return 'Tech stack analysis is in progress..identifying all the underlying technologies to tailor the next steps of the test.';
    }
  },
  [MESSAGE_TYPES.EXTERNAL_TECHSTACK]:
    'The test is underway. Kicking off the Tech Stack Analysis to discover all public-facing technologies and build a complete profile of your asset.',
  [MESSAGE_TYPES.INTERNAL_TECHSTACK]:
    'Tech stack analysis is in progress..identifying all the underlying technologies to tailor the next steps of the test.',

  [MESSAGE_TYPES.TARGET_AUTHENTICATION]:
    "Attempting to log in.....I'm now using the provided credentials to attempt a secure login to your application. Stand by..",

  [MESSAGE_TYPES.CDSA_AUTH]:
    "I'm starting a deep crawl of your application as a logged-in user to discover all protected pages and functions. As each one is found, I'll begin actively testing it for a wide range of vulnerabilities.",
  [MESSAGE_TYPES.CDSA_UNAUTH]:
    "I'm starting a comprehensive crawl of your application from a public perspective. As I discover each page and function, I'll begin actively testing it for a wide range of vulnerabilities.",
  // Scenario-flow DSA (activity 23) crawls from a public perspective — same copy as CDSA_UNAUTH,
  // shown as soon as the activity's in-progress card is created.
  [MESSAGE_TYPES.DYNAMIC_SECURITY_ANALYSIS]:
    "I'm starting a comprehensive crawl of your application from a public perspective. As I discover each page and function, I'll begin actively testing it for a wide range of vulnerabilities.",
  [MESSAGE_TYPES.API_GRAPHQL_SCAN]:
    "I'm mapping your GraphQL schema from a public access point and identifying how queries are processed. As each behavior is identified, active testing begins to uncover common API security risks.",
  [MESSAGE_TYPES.CVE]:
    "I'm now scanning all the components of your application to see if any match up with known security flaws (CVEs) that hackers could exploit.",
  [MESSAGE_TYPES.SDEA]:
    'Next, testing your web application for potential sensitive data exposures.',
  [MESSAGE_TYPES.GENERAL_SECURITY]:
    "It's time to check for 'unlocked windows'. This activity looks for common misconfigurations and information leaks (like server versions) that could give an attacker a foothold.",
  [MESSAGE_TYPES.SECURITY_MISCONFIGURATION_ANALYSIS]:
    'Checking for common security misconfigurations that could expose internal data or logic.',
  [MESSAGE_TYPES.TEST_CASES_CURATION]: (msg) => {
    const testType = msg?.metadata?.test_configuration?.testType;
    if (testType === 'quick') {
      return "The test plan is now set. For this express test, I'm focusing on critical vulnerabilities and common misconfigurations and curating the test-cases..";
    } else if (testType === 'wordpress') {
      return 'The test plan is now set. Based on an analysis of your WordPress core, installed plugins, and active theme, I am putting together the test-cases..';
    } else {
      // Default for 'normal' or any other test type
      return 'The test plan is now set. Curating test cases based on  full crawl strategy, token validation, and module calibration..';
    }
  },
  [MESSAGE_TYPES.VPN]:
    "Setup complete! I'm now establishing a secure VPN connection and beginning to map your internal application. The test is officially underway!",
  [MESSAGE_TYPES.TEST_SETUP]: {
    [MESSAGE_STATUS.IN_PROGRESS]:
      "Alright, I'm digging in now to set up the environment and pull all the required components together. Hang tight, this typically takes a couple of minutes to get everything primed!",
    [MESSAGE_STATUS.COMPLETED]:
      "Alright, I'm digging in now to set up the environment and pull all the required components together. Hang tight, this typically takes a couple of minutes to get everything primed!",
    completionMessage:
      'All primed and ready! The environment is set up and every component is in place. Moving on to the next activity.',
  },
  [MESSAGE_TYPES.DEFAULT_CHECKS]:
    "Let's 'jiggle the locks.' I'm running a check for any default credentials, common weak passwords, or hardcoded keys that could be used to gain unauthorized access.",
  [MESSAGE_TYPES.SSL_TLS]:
    "I'm now starting the SSL/TLS Configuration review. This is a critical check of your 'digital handshake' to ensure you're not using outdated, insecure protocols (like TLS 1.0 or 1.1) that could allow data to be intercepted.",
  [MESSAGE_TYPES.CONTENT_DISCOVERY]:
    "The fuzzing process has begun. This scan searches for any hidden files, folders, or admin panels that aren't meant to be public.",
  [MESSAGE_TYPES.FINDING_OPTIMIZATION]:
    "All testing-activities are complete! Moving to the final step. I'm now processing all the raw data: de-duplicating findings, updating their status, and initiating AI enrichment to provide you with the clearest, most actionable results.",
  [MESSAGE_TYPES.UNAUTH_WORDPRESS_VA]:
    "I'm running a deep check of its core files, installed plugins, and active theme to find any known vulnerabilities an attacker could exploit without logging in.",
  [MESSAGE_TYPES.AUTH_WORDPRESS_VA]:
    "I'm in! Now that I'm authenticated, I'm starting the Authenticated Test. This is a much deeper check where I'll test for vulnerabilities from a logged-in user's perspective, looking for flaws or access to other users' data.",
  [MESSAGE_TYPES.FIREWALL_RESTRICTION]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `We attempted to reach your new asset **"${assetName}"** but received no response. This usually happens due to firewall restrictions, or the asset being offline. You can troubleshoot the connection and restart the test.`;
  },
  [MESSAGE_TYPES.API_COLLECTION]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'PetStore API';
    return `Great, we recognize this one! **${assetName}** has been tested before. We need to validate the current environment before loading your previous settings. Please confirm the existing collection source or modify to continue.`;
  },
  [MESSAGE_TYPES.API_DSA]:
    "I've processed your API collection and am now starting the test. This test will check each of your defined endpoints for common vulnerabilities like data leaks, injection, and broken access control.",
  [MESSAGE_TYPES.TEST_TERMINATE]:
    'The test has been stopped. Please review your configuration and try again.',

  // Error code messages for TEST_TERMINATE
  E01: {
    message:
      "The test has been stopped. Looks like the login didn't go through. Give your authentication details a quick check and try again.",
    failureBox: "We couldn't validate the provided credentials.",
    showStartOver: true,
  },
  E02: {
    message:
      'The test has been stopped. We lost access to your internal network. Please double-check your VPN credentials and reconnect, then retry the test.',
    failureBox: 'We lost access to the internal network.',
    showStartOver: true,
  },
  E03: {
    message:
      "The test has been stopped. We couldn't reach the asset. Check that it's online and accessible over your VPN, then retry the test.",
    failureBox: "The target asset isn't responding through the VPN.",
    showStartOver: true,
  },
  E04: {
    message: (msg) => {
      const redirectedUrl =
        msg?.metadata?.validation_response?.validated_target_url ||
        msg?.metadata?.redirected_url ||
        msg?.metadata?.latest_session?.redirect_url ||
        'the redirected URL';
      return `The target URL redirected to **${redirectedUrl}**, which isn't the one declared for the test, so we've stopped the test. If you wish to test this new URL, simply start a new test with the updated link.`;
    },
    failureBox: (msg) => {
      const redirectedUrl =
        msg?.metadata?.validation_response?.validated_target_url ||
        msg?.metadata?.redirected_url ||
        'the redirected URL';
      return `The target redirected to **${redirectedUrl}**, which differs from the declared target.`;
    },
    showStartOver: true,
  },
  E05: {
    message:
      "The test has been stopped. Since the redirected URL wasn't approved, the process couldn't continue. But you can start a fresh test using the redirected link if needed.",
    failureBox: "The new redirected URL wasn't approved.",
    showStartOver: true,
  },
  E06: {
    message: (msg) => {
      const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
      return `We attempted to reach the asset **"${assetName}"** but received no response. This may happen when the asset is unreachable or temporarily offline. Please check the asset's availability and restart the test.`;
    },
    failureBox: 'The asset did not respond to our requests.',
    showStartOver: true,
  },
  E07: {
    message:
      "The test has been stopped because the asset's WAF is interfering with our test requests. To ensure we can accurately assess the asset's security posture, please **whitelist our IP address: 44.206.15.87** to run the test successfully.",
    failureBox: 'WAF is interfering with test requests.',
    showStartOver: true,
  },
  E08: {
    message:
      'The test has been stopped due to strict request throttling on the asset environment. This throttling prevents the throughput required for a complete analysis. Please relax these limits or **whitelist our IP address: 44.206.15.87** to ensure the test runs successfully.',
    failureBox: 'Target rate-limiting threshold exceeded.',
    showStartOver: true,
  },
  E09: {
    message:
      'The test has been stopped because the target is unresponsive due to block on our IP address. To reach the host and validate findings, please unblock and **whitelist our IP address: 44.206.15.87** to run the test successfully.',
    failureBox: 'Host unreachable; network blocking detected.',
    showStartOver: true,
  },
  E10: {
    message: (msg) => {
      const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'Asset Name';
      return `I see **${assetName}** is already in your inventory.\n\nHowever, it is currently marked as decommissioned. Tests cannot be run until you reactivate it. Please update the status to 'Active' in the **Assets listing** and try again.`;
    },
    failureBox: 'The asset is marked as decommissioned.',
    showStartOver: false,
  },
  E99: {
    message:
      "The test has been stopped. Something didn't go as expected. Try running it again, and if the issue continues, feel free to contact support.",
    failureBox: 'An unexpected issue interrupted the process.',
    showStartOver: true,
  },
  E11: {
    message:
      "The test has been stopped because the endpoints defined in your API collection do not match the target URL configured for this test. To proceed, please ensure your collection's addresses point to the intended target environment and try again.",
    failureBox: 'Host mismatch detected between API collection and target URL.',
    showStartOver: true,
  },
  // E13 — invalid resource ID (IDOR baseline/target id non-2xx; maps from EI06). New code, no collision.
  E13: {
    message:
      'The test has been stopped because one of the provided object IDs could not be accessed with the supplied credentials. Please review the **Allowed**/**Not Allowed** IDs you entered and make sure the Allowed ID is a resource the token can legitimately reach, then try again.',
    failureBox: 'An object ID provided for IDOR testing was invalid or inaccessible.',
    showStartOver: true,
  },
  // IDOR (EI*) error codes — gpt-engine persists these on the session/activity. Surfaced directly
  // rather than remapped to E* (E11 is already taken by the API-collection host-mismatch flow).
  EI01: {
    message:
      "The test has been stopped. I couldn't fetch your API collection. Please confirm the collection file or spec URL is reachable and try again.",
    failureBox: 'Failed to fetch the API collection / spec.',
    showStartOver: true,
  },
  EI02: {
    message:
      "The test has been stopped. I couldn't parse your API collection. Please make sure it's a valid OpenAPI/Swagger (JSON or YAML) document and try again.",
    failureBox: 'The API collection could not be parsed.',
    showStartOver: true,
  },
  EI03: {
    message:
      "Good news! No endpoints susceptible to IDOR were found in your collection. There's nothing to test for object-level access here. To get broader coverage, you can start over and select DAST analysis, or upload a new collection.",
    failureBox: null,
    showStartOver: true,
  },
  EI04: {
    message:
      "The test has been stopped. My analysis engine didn't respond in time while working through your API. This is usually temporary — please try running the test again.",
    failureBox: 'The AI analysis step timed out or was throttled.',
    showStartOver: true,
  },
  EI07: {
    message:
      "I couldn't authenticate to the target with the credentials provided. Please update your authentication details and I'll verify them again before we continue.",
    failureBox: 'Authentication to the target failed (the probe request was not successful).',
    showStartOver: true,
  },
  EI99: {
    message:
      "The test has been stopped. Something didn't go as expected during the IDOR analysis. Try running it again, and if the issue continues, feel free to contact support.",
    failureBox: 'An unexpected issue interrupted the IDOR analysis.',
    showStartOver: true,
  },

  // IDOR agent widget intro/assistant copy (verbatim from Figma IDOR-flow).
  [MESSAGE_TYPES.IDOR_FETCHING_COLLECTION]:
    "I've mapped all your available endpoints. Next, I'll pass them to the IDOR Agent to: identify relevant ones, refine the scope, and map the required object parameters. You'll be able to review and exclude anything you want to skip before we proceed.",
  [MESSAGE_TYPES.IDOR_AUTH_VERIFICATION]:
    "I ran a sample request against the target to verify the credentials we'll use to access the environment. Here's what came back.",
  [MESSAGE_TYPES.IDOR_REFINE_SCOPE]:
    "I've mapped the attack surface. Please review the probable IDOR endpoints below. Exclude any you don't want me to touch, and I'll adapt the strategy.",
  [MESSAGE_TYPES.IDOR_OBJECT_ACCESS]:
    "Now, I need you to define the access boundaries. Provide an 'Allowed' ID the user rightfully owns, and a 'Not Allowed' ID the user shouldn't be able to access. I will attempt to access the \"Not Allowed\" records using your provided token.",
  [MESSAGE_TYPES.IDOR_DECLARATION]:
    'We are **go for launch!** 🚀. Your test configuration is locked in. Just one final pre-flight check: Please review and confirm the declaration to start the test!',
  [MESSAGE_TYPES.IDOR_PROGRESS]:
    "I've started the IDOR analysis now. The IDOR Agent will take it from here, checking how access is handled across different objects to spot any gaps.",
  [MESSAGE_TYPES.IDOR_FINDINGS]:
    "All testing activities are complete! Moving to the final step. I'm now processing all the raw data: de-duplicating findings, updating their status, and initiating AI enrichment to provide you with the clearest, most actionable results.",

  // ROAR-4729: candidate_analysis found zero IDOR-susceptible endpoints. Shared by
  // both coverages — rendered inside the IDOR Agent card in place of the fetching
  // pipeline when the FETCHING_COLLECTION message carries `no_candidates: true`.
  IDOR_NO_CANDIDATES_BODY:
    "I analyzed every endpoint in your collection file and didn't find any with object-reference parameters in the paths or payloads, the kind of identifiers IDOR testing targets. Your collection looks clean on this front.",
  // Comprehensive/CompSec only: the "continuing on to DAST" bubble rendered as a
  // separate message immediately above an idor_declaration carrying dast_only:true
  // (derived at render time from that one persisted message — see GenPTChatPanel).
  IDOR_NO_CANDIDATES_DAST_BUBBLE:
    "Good news! No endpoints susceptible to IDOR were found in your collection. There's nothing to test for object-level access here. Continuing on to DAST analysis now.",

  // ROAR-4923 #3: the agent intro rendered as a separate bubble immediately above the AISO Scenario
  // Execution widget when a business-scenario run starts (mirrors the DAST bubble pattern above).
  AISO_SCENARIO_INTRO_BUBBLE:
    'Activating the AISO agent to execute your scenario against the live target. It will traverse the defined flow, intercept HTTP traffic, and surface all testable endpoints for the GenPT test.',

  [MESSAGE_TYPES.EXTERNAL_REACHABILITY_CHECK]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Excellent! **${assetName}** is already in your inventory. I will attempt to reach the asset to verify if it is accessible for testing. This will just take a moment.`;
  },
  [MESSAGE_TYPES.REDIRECTION]: (msg) => {
    const redirectedUrl =
      msg?.metadata?.validation_response?.validated_target_url || 'the redirected URL';
    return `Heads up! We detected a detour.\n\nThe provided link is redirecting us to: **${redirectedUrl}**\n\nDo you want to follow this path and test the redirected URL, or cancel the test.`;
  },
  [MESSAGE_TYPES.NOT_REACHABLE]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `We attempted to reach the asset **"${assetName}"** but received no response. This usually happens due to firewall restrictions, or the asset being offline. We recommend you troubleshoot the connection and restart the test.`;
  },
  [MESSAGE_TYPES.NEW_ADDED_EXTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Locked in! **${assetName}** has been added successfully. 🎉 I will attempt to reach the asset to verify it is accessible for testing. This will just take a moment.`;
  },

  // New message types from backend
  [MESSAGE_TYPES.WEB_EXISTING_EXTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Excellent! **${assetName}** is already in your inventory. I will attempt to reach the asset to verify if it is accessible for testing. This will just take a moment.`;
  },
  [MESSAGE_TYPES.WEB_EXISTING_EXTERNAL_REACHABLE_NO_REDIRECTION_NO_HISTORY]:
    'Alright, I’ve reviewed this asset. Since this is its first security test, it’s a great time to set a baseline. Let’s move ahead with the initial setup and choose how the test should run.',
  [MESSAGE_TYPES.WEB_EXISTING_EXTERNAL_REACHABLE_NO_REDIRECTION_HISTORY]:
    'Great news! Your asset is reachable, and I’ve pulled in the last setup for you. You can run it right away, or modify the setup if you’d like to change the configuration or throttling.',
  [MESSAGE_TYPES.WEB_EXTERNAL_REACHABLE_REDIRECTION]: (msg) => {
    const redirectedUrl =
      msg?.metadata?.validation_response?.validated_target_url || 'the redirected URL';
    return `Heads up! We detected a detour.\n\nThe provided link is redirecting us to: **${redirectedUrl}**\n\nDo you want to follow this path and test the redirected URL, or cancel the test.`;
  },
  [MESSAGE_TYPES.EXTERNAL_NOT_REACHABLE]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `We attempted to reach the asset **"${assetName}"** but received no response. This usually happens due to firewall restrictions, or the asset being offline. We recommend you troubleshoot the connection and restart the test.`;
  },
  [MESSAGE_TYPES.WEB_EXISTING_INTERNAL_NO_HISTORY]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Excellent! **${assetName}** is in your inventory and hasn’t been tested yet. That makes this a great moment to set a baseline. Let’s get the first test set up.`;
  },
  [MESSAGE_TYPES.WEB_EXISTING_INTERNAL_HISTORY]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Great, we recognize this one! **${assetName}** has been tested before. I’ve pulled in the last setup so you can jump right in, or modify the setup if you’d like to change the configuration or throttling.`;
  },
  [MESSAGE_TYPES.API_EXISTING_EXTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'Asset name';
    return `Great, we recognize this one! **${assetName}** is already in your inventory. I will attempt to reach the asset to verify if it is accessible for testing. This will just take a moment.`;
  },
  [MESSAGE_TYPES.API_EXISTING_EXTERNAL_REACHABLE]:
    'Alright, before we move to test configuration, we just need one quick detail. Please share the Collection Source below.',
  [MESSAGE_TYPES.API_EXISTING_EXTERNAL_NOT_REACHABLE]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'Asset Name';
    return `We attempted to reach the asset **"${assetName}"** but received no response. This may happen when the asset is unreachable or temporarily offline. Please check the asset's availability and restart the test.`;
  },
  [MESSAGE_TYPES.API_EXISTING_INTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Great, we recognize this one! **${assetName}** is already in your inventory. Before moving to test configuration, please share the Collection Source below.`;
  },
  [MESSAGE_TYPES.NEW_ASSET]:
    "Ooh, uncharted territory! This asset isn't in the registry yet. Let's get it onboarded and ready for action. Please fill in the details below, and I'll create its profile for all future tests.",
  [MESSAGE_TYPES.WEB_NEW_ADDED_EXTERNAL_REACHABLE_NO_REDIRECTION]:
    "Great! Now, let's build the game plan. To run the test successfully, I need a few more details. Please set the test type, access level, and test strategy, and I’ll take it from there.",
  [MESSAGE_TYPES.WEB_NEW_ADDED_INTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Locked in! **${assetName}** has been added successfully. 🎉\n\nNow, let's build the game plan. To run the test successfully, I need a few more details. Please set the test type, access level, and test strategy, and I’ll take it from there.`;
  },
  [MESSAGE_TYPES.API_NEW_ADDED_EXTERNAL_REACHABLE]:
    "Moving on, let's build the game plan.  To get started, please provide the Collection source (URL or File) below so we can map the endpoints.",
  [MESSAGE_TYPES.API_NEW_ADDED_INTERNAL]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'your asset';
    return `Locked in! **${assetName}** has been added successfully 🎉.  To get started, please provide the Collection source (URL or File) below so we can map the endpoints.`;
  },
  [MESSAGE_TYPES.API_EXISTING_NO_HISTORY]:
    "Thanks! Looks like the asset is new to testing. This is the perfect time to establish a baseline. Let's get its first security test configured!",
  [MESSAGE_TYPES.API_EXISTING_HISTORY]:
    'Alright! To save your time, I’ve pulled in the last setup for you. You can run it right away, or modify the setup if you’d like to change the configuration or throttling.',
  [MESSAGE_TYPES.API_INVALID_COLLECTION]: '',
  [MESSAGE_TYPES.API_NEW_ADDED_VALID_COLLECTION]:
    "Great! Now, let's build the game plan. To run the test successfully, I need a few more details. Please set the test type, access level, and test strategy, and I’ll take it from there.",
  [MESSAGE_TYPES.TEST_IN_PROGRESS]:
    'A test is currently in progress for this URL. Please wait until it completes before starting a new one.',
  [MESSAGE_TYPES.WAF_DETECTED]: (msg) => {
    const whitelistIp = msg?.metadata?.validation_response?.whitelist_ip || '44.206.15.87';
    return `The asset appears to be protected by a Web Application Firewall (WAF). Active interference from these controls may result in high latency, incomplete coverage, or false negatives. To ensure a comprehensive assessment, I recommend the following:\n• **Whitelist our IP address: ${whitelistIp}**\n• **Configure firewalls and DDoS protection to permit our traffic**\n• **Ease strict rate-limiting policies while testing is in progress**\nYou may proceed with the test, but please be advised that it will impact the accuracy of the results.`;
  },
  [MESSAGE_TYPES.ASSET_PERMISSION_DENIED]: (msg) => {
    const assetName = msg?.metadata?.asset?.name || msg?.widget?.data?.assetName || 'this asset';
    return `I've located this URL and it's already tied to **${assetName}** in your company inventory. I can't kick off a GenPT test here yet since only assigned users can run tests.\n\nPlease ask your administrator to assign you as a POC for this asset in the Pentest Module. Meanwhile, you can continue testing other assets that are already assigned to you.`;
  },
  [MESSAGE_TYPES.STATUS_CODE_404]:
    'Hey there! The provided URL returned a **404 Not Found** response. This usually means the endpoint may have moved, been removed, or the URL might be incorrect. Would you like to continue testing this asset anyway?',
  [MESSAGE_TYPES.STATUS_CODE_403]:
    'A quick check returned a **403 Forbidden response** for the provided URL. Access to this endpoint is currently restricted. Would you like to continue testing this asset anyway?',

  /**
   * `scheduled_run_started` system bubble shown right after `initial` on scheduled runs only.
   * Values come directly from `msg.widget` (BE pre-resolves them). Both interpolated values
   * are wrapped in `**...**` so the existing `formatText` (in GenPTChatPanel) bolds them.
   *
   * Fallbacks:
   *   - schedule_name null  → drop the "your <name> schedule" wrapping and read
   *                           "as part of **the scheduled run**" (per spec copy).
   *   - asset_name null     → use the asset URL from msg metadata
   *                           (asset.url → asset.original_target_url),
   *                           else "the selected asset".
   */
  [MESSAGE_TYPES.SCHEDULED_RUN_STARTED]: (msg) => {
    const widgetData = msg?.widget || {};
    const rawScheduleName =
      typeof widgetData.schedule_name === 'string' ? widgetData.schedule_name.trim() : '';
    const rawAssetName =
      typeof widgetData.asset_name === 'string' ? widgetData.asset_name.trim() : '';

    const metadataAssetUrl =
      (typeof msg?.metadata?.asset?.url === 'string' && msg.metadata.asset.url.trim()) ||
      (typeof msg?.metadata?.asset?.original_target_url === 'string' &&
        msg.metadata.asset.original_target_url.trim()) ||
      '';
    const assetName = rawAssetName || metadataAssetUrl || 'the selected asset';

    const scheduleClause = rawScheduleName
      ? `as part of your **${rawScheduleName}** schedule`
      : `as part of **the scheduled run**`;

    return `I've just initiated the automated security test for **${assetName}** ${scheduleClause}. I'll work through each activity in sequence and surface the results as soon as the test wraps up.`;
  },
};

export const getMessageText = (msg, targetURL = null, url = null) => {
  // If message has explicit text, use it
  if (msg.text) {
    return msg.text;
  }

  // Check for error codes first (e01, e02, etc.)
  // Only check error codes if message type or widget type suggests it's an error message
  const validErrorCodes = [
    'E01',
    'E02',
    'E03',
    'E04',
    'E05',
    'E06',
    'E07',
    'E08',
    'E09',
    'E10',
    'E11',
    'E13',
    'E99',
    'EI01',
    'EI02',
    'EI03',
    'EI04',
    'EI07',
    'EI99',
  ];
  const normalizedType = msg?.type ? msg.type.toUpperCase() : null;
  const widgetType = msg?.widget?.type ? msg.widget.type.toUpperCase() : null;
  const isMessageTypeError = normalizedType && validErrorCodes.includes(normalizedType);
  const isWidgetErrorCode = widgetType && validErrorCodes.includes(widgetType);

  let errorCode = null;
  // Only check for error codes if message type or widget type is an error code
  if (isMessageTypeError) {
    errorCode = normalizedType;
  } else if (isWidgetErrorCode) {
    errorCode = widgetType;
  } else if (
    msg?.widget?.type === MESSAGE_TYPES.TEST_TERMINATE ||
    normalizedType === 'E10' ||
    widgetType === 'E10'
  ) {
    // For TEST_TERMINATE widget or E10, check for error code in message fields
    const codeFromMsg =
      msg?.error_code || msg?.metadata?.error_code || msg?.widget?.data?.error_code || null;
    errorCode = codeFromMsg ? codeFromMsg.toUpperCase() : null;
  }

  if (errorCode && validErrorCodes.includes(errorCode) && MESSAGES[errorCode]) {
    // Always return the error message text so both message and widget are displayed
    const errorDetails = MESSAGES[errorCode];
    if (typeof errorDetails.message === 'function') {
      const message = errorDetails.message(msg);
      return typeof message === 'string' ? message : String(message || '');
    }
    return typeof errorDetails.message === 'string'
      ? errorDetails.message
      : String(errorDetails.message || '');
  }

  // Get message text based on msg.type only
  const messageType = msg.type;

  if (!messageType) {
    return '';
  }

  // Get message from MESSAGES object
  const message = MESSAGES[messageType];

  if (!message) {
    return '';
  }

  // Handle function messages (like INITIAL, TEST_CASES_CURATION)
  if (typeof message === 'function') {
    // For INITIAL, pass URL; for others like TEST_CASES_CURATION, pass the full msg object
    if (messageType === MESSAGE_TYPES.INITIAL) {
      const finalUrl = url || msg.targetURL || msg.target_url || targetURL || '';
      const result = message(finalUrl);
      return typeof result === 'string' ? result : String(result || '');
    } else {
      const result = message(msg);
      return typeof result === 'string' ? result : String(result || '');
    }
  }

  // Handle object messages with status (like TEST_START, TEST_START_VPN)
  if (typeof message === 'object' && message !== null) {
    // Check if it's a status-based object (has IN_PROGRESS, COMPLETED keys)
    if (message[MESSAGE_STATUS.IN_PROGRESS] || message[MESSAGE_STATUS.COMPLETED]) {
      const status = msg.status || MESSAGE_STATUS.IN_PROGRESS;
      return message[status] || message[MESSAGE_STATUS.IN_PROGRESS] || '';
    }

    // Handle objects with methods (like TEST_CONFIGURATION_NEW_ASSET with withAsset)
    if (message.withAsset) {
      const assetName = msg.metadata?.asset?.name || '';

      if (assetName) {
        return message.withAsset(assetName);
      }

      return message.default || '';
    }
  }

  // Handle string messages
  const finalMessage = message || '';
  return typeof finalMessage === 'string' ? finalMessage : String(finalMessage);
};

// Get completion message for a message type if it exists
export const getCompletionMessage = (messageType) => {
  if (!messageType) return null;
  const message = MESSAGES[messageType];
  return message?.completionMessage || null;
};
